import type { ReportLayoutConfig, SectionBuild } from '@/features/reports'

// v3 `configs/MarketingInsights/SearchMarketing/DisplayVideo360.js` (23 ln). Static single-tab
// section: v3's numeric `id: 43` becomes the string '43' (ids stringify downstream anyway),
// the returned `channel: 'dv_360'` logo hint drops (section chrome in v4), and the title-only
// tab (`{title: 'Overview'}`, no machine name) folds into the identical section title — the
// tab's machine name stays ''. Page-tab `isNotTabCard` has no v4 field.

const DISPLAY_VIDEO_360_REPORT_ID = 43

const displayVideo360Build: SectionBuild = () => ({
  id: '43',
  reportId: DISPLAY_VIDEO_360_REPORT_ID,
  scheduleTabs: ['default'],
})

export const DISPLAY_VIDEO_360: ReportLayoutConfig = [
  {
    name: 'Overview',
    labelKey: 'marketingInsights.displayVideo360.tabs.overview',
    sections: [
      {
        id: '43',
        titleKey: 'marketingInsights.displayVideo360.overview.title',
        reportId: DISPLAY_VIDEO_360_REPORT_ID,
        tabs: [{ name: '', tabs: ['default'] }],
        build: displayVideo360Build,
      },
    ],
  },
]
